import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useToggleSaveMyContent } from 'actions/content';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
function Save(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset;
  var _useToggleSaveMyConte = useToggleSaveMyContent({
      id: Number(asset === null || asset === void 0 ? void 0 : asset.id),
      isSaved: !(asset !== null && asset !== void 0 && asset.isSaved),
      isAsset: true
    }),
    toggleSaveContent = _useToggleSaveMyConte.toggleSaveContent;
  if (!asset) return null;
  return /*#__PURE__*/React.createElement(Component, {
    icon: "favourite",
    isActive: asset === null || asset === void 0 ? void 0 : asset.isSaved,
    onClick: function onClick() {
      return toggleSaveContent({
        id: asset.id,
        isAsset: true
      });
    },
    "data-qa": "save-for-later",
    id: "actionpanel_favourite_button_".concat(asset.id)
  }, asset.isSaved ? t('actions_saved_for_later') : t('actions_save_for_later'));
}
export default Save;